import React from 'react';

import Tooltip from '~/components/tooltip/tooltip';

import styles from '~/components/seed/seed-finder.module.scss';

const FeatureBadge = ({ icon, text, tooltipText }) => {
  if (tooltipText) {
    return (
      <Tooltip
        content={tooltipText}
        className={styles.badgeTooltip}
        variant="light"
      >
        <div className={styles.badge}>
          {icon && <img src={icon.src} alt={icon.alt} height="24" width="24" />}
          {text}
        </div>
      </Tooltip>
    );
  }
  return (
    <div className={styles.badge}>
      {icon && <img src={icon.src} alt={icon.alt} />}
      {text}
    </div>
  );
};

export default FeatureBadge;
